import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=3dfa4bd0&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa4bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dfa4bd0')) {
      api.createRecord('3dfa4bd0', component.options)
    } else {
      api.reload('3dfa4bd0', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=3dfa4bd0&scoped=true&", function () {
      api.rerender('3dfa4bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NT4PYv3D7b24/JS/comp/SearchFilterTokens.vue"
export default component.exports